import { createFileRoute } from "@tanstack/react-router";
import { redirectIntoScope } from "@/app/router/legacy-redirect";

/** Old unscoped URL: `/opportunities/…` → `/{store}/opportunities/…`. */
export const Route = createFileRoute("/opportunities/$")({ beforeLoad: redirectIntoScope });
